module.exports = __webpack_public_path__ + "7bce3122dd358a8489b57a7b44856c69.svg";